import React from 'react';
import { clsx } from 'clsx';
import { Icon } from '@/ui/icons/Icon';
import { formatAmountWithSpacesAndSymbol } from '@/lib/amountUtils';
import styles from './CreditLineCosts.module.scss';
import { externalUrls } from '@/constants/urls';

export interface CreditLineCostsProps {
  monthlyCost: number;
  minimumPayment: number;
  className?: string;
}

export const CreditLineCosts: React.FC<CreditLineCostsProps> = ({
  monthlyCost,
  minimumPayment,
  className,
}) => {
  return (
    <div className={clsx(styles.costCard, className)}>
      <div className={styles.costRow}>
        {/* Monthly Cost */}
        <div className={styles.costItem}>
          <p className={styles.costLabel}>Cost lunar</p>
          <div className={styles.costAmount}>
            {formatAmountWithSpacesAndSymbol(monthlyCost, 'lei')}
          </div>
        </div>

        {/* Minimum Payment */}
        <div className={styles.costItem}>
          <div className={styles.minimumPaymentHeader}>
            <p className={styles.costLabel}>Minim de plată</p>
            <div
              className={styles.infoIcon}
              onClick={() => {
                window.open(
                  externalUrls.oceanCredit.creditLineDetails,
                  '_blank'
                );
              }}
            >
              <Icon name="info-circle" />
            </div>
          </div>
          <div className={styles.costAmount}>
            {formatAmountWithSpacesAndSymbol(minimumPayment, 'lei')}
          </div>
        </div>
      </div>
    </div>
  );
};
